import { Switch } from '@beeinventor/dasiot-react-component-lib';
import { styled } from '@mui/material';

const List = styled('ul')`
  padding: 0;
  & > li {
    display: flex;
    gap: 10px;
    align-items: center;
    list-style-type: none;
  }

  & > .text-field {
    margin-top: 10px;
  }
`;

interface DasVProDialogContentProps {
  metadata: {
    [propertyName: string]: any;
  };
  onChange: (propertyName: string, value: any) => void;
}

const DasVProDialogContent: React.FC<DasVProDialogContentProps> = ({
  metadata,
  onChange,
}) => {
  return (
    <List>
      <li>
        <Switch
          checked={!!metadata.vodPreview}
          onChange={(_, checked) => onChange('vodPreview', checked)}
        />
        <span>Preview 10s</span>
      </li>
    </List>
  );
};

export default DasVProDialogContent;
